import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './RightToService.css';

const RightToService = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['सेवेचा अधिकार', 'सेवा', 'अर्ज', 'कालबद्ध सेवा'],
    en: ['right to service', 'service', 'application', 'time bound service']
  });

  const pageHeaderData = {
    title: {
      marathi: 'सेवेचा अधिकार',
      english: 'Right To Service'
    },
    subtitle: {
      marathi: 'सेवेचा अधिकार अधिनियम २०१५ अंतर्गत माहिती',
      english: 'Information under Right To Service Act 2015'
    }
  };

  return (
    <div className="right-to-service">
      <div className="right-to-service-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="right-to-service-content" data-read-section="right-to-service-content">
          {/* Right To Service Table */}
          <section className="right-to-service-section">
            <div className="right-to-service-table-container">
              <table className="right-to-service-table">
                <thead>
                  <tr>
                    <th>
                      {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
                    </th>
                    <th>
                      {isMarathi() ? 'तपशील' : 'Details'}
                    </th>
                    <th>
                      {isMarathi() ? 'परिपत्रक' : 'Circular'}
                    </th>
                    <th>
                      {isMarathi() ? 'दिनांक' : 'Date'}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="right-to-service-serial">
                      {isMarathi() ? '१' : '1'}
                    </td>
                    <td className="right-to-service-details">
                      {isMarathi() ? 'सेवा हक्क कायदा २०१५ अंतर्गत माहिती' : 'Information under the Right To Service Act 2015'}
                    </td>
                    <td className="right-to-service-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/right-to-service/information-under-right-to-service-act-2015.pdf" 
                        className="right-to-service-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="right-to-service-na">NA</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RightToService;
